import React from "react";
// import Button from "../../../../components/elements/forms/Button2";
// import { useNavigate } from "react-router-dom";

const ReadyToEnsure: React.FC = () => {
  // const navigate = useNavigate();
  return (
    <div className="bg-[#0F172A] bg-cover bg-center md:h-[400px] h-[300px] w-full font-abel flex items-center">
      <div className="text-center text-[white] max-w-[925px] mx-auto">
        <h3 className="text-3xl md:text-6xl">
          Ready to Ensure Your Talent Success?
        </h3>
        <p className="text-[16px] md:text-[20px] font-[400] pt-3 max-w-[835px] mx-auto">
          Don't leave your leadership investment to chance. Let's discuss how
          our Post-Placement Success Packages can protect and enhance your
          executive hire.
        </p>
        {/* <div className="flex items-center justify-center">
          <Button
            className="bg-[#2D6EEF] text-[#ffffff] md:h-[55px] md:w-[194px] md:text-[17px] mt-5 transition-colors shadow-lg hover:shadow-xl transform hover:scale-101"
            title="Explore Packages"
            onSubmitHandler={() => navigate(`/`)}
          />
          <div className="w-[10px]"></div>
          <Button
            className="bg-[#ffffff] text-[#000000] md:h-[55px] md:w-[194px] md:text-[17px] mt-5 transition-colors shadow-lg hover:shadow-xl transform hover:scale-101"
            title="Schedule Consultation"
            onSubmitHandler={() => navigate(`/`)}
          />
        </div> */}
      </div>
    </div>
  );
};

export default ReadyToEnsure;
